import { Directive, HostListener, ElementRef } from '@angular/core';

const COMPARED_ELEMENT_APPEARS_BEFORE = 4;

@Directive({
  selector: '[focusFirstInvalidField]',
})
export class FocusFirstFormErrorDirective {
  constructor(private el: ElementRef) {}

  @HostListener('submit')
  onFormSubmit() {
    setTimeout(() => {
      const firstErrorWrapper = document.querySelector(
        '.ng-invalid:not(form, div)'
      );

      const firstControlAccessorElementWithError =
        firstErrorWrapper?.querySelector(
          'input, select, textarea'
        ) as HTMLElement;

      const firstInputWithError = document.querySelector(
        'input.ng-invalid, button.ng-invalid, select.ng-invalid'
      ) as HTMLElement;

      if (firstControlAccessorElementWithError && firstInputWithError) {
        if (
          firstControlAccessorElementWithError?.compareDocumentPosition(
            firstInputWithError
          ) === COMPARED_ELEMENT_APPEARS_BEFORE
        ) {
          firstControlAccessorElementWithError.focus();
        } else {
          firstInputWithError.focus();
        }
      } else if (firstControlAccessorElementWithError) {
        firstControlAccessorElementWithError.focus();
      } else if (firstInputWithError) {
        firstInputWithError.focus();
      }
    }, 0);
  }
}
